import {API, Entities} from "../../utils/Api";
import {useState} from "react";

export function EmailUs(){
    const [finished,setFinished] = useState(false);
    async function submitQuestion(){

        var email = document.getElementById('email').value;
        var name = document.getElementById('name').value;
        var message = document.getElementById('message').value;

        try {
            const response = await API.rest(Entities.email,"POST", {
                email: email,
                name: name,
                message: message
            });

            if(response.status=='success'){
                const section = document.getElementById('emailus');
                const nav = document.querySelector('nav');
                if (section) {
                    // kiszámoljuk a nav magasságát
                    const navHeight = nav ? nav.offsetHeight : 0;

                    // lekérjük a szekció pozícióját az oldalon
                    const sectionTop = section.getBoundingClientRect().top + window.scrollY;

                    // smooth scroll nav magasság mínusszal
                    window.scrollTo({
                        top: sectionTop - navHeight, // nav magasságával korrekció
                        behavior: 'smooth'
                    });
                }
                setFinished(true);
            }

        } catch (error) {
            console.error("Hiba történt az API hívás során:", error);
            return { key:[] }; // Hiba esetén üres tömböt adunk vissza
        }

    }

    return (
        <section className="bg-very-light-gray position-relative" id={'emailus'}>
            <div className="container">
                <div className="row mb-8">
                    <div className="col-xl-5 col-lg-6 md-mb-50px"
                         data-anime='{ "el": "childs", "translateX": [-50, 0], "opacity": [0,1], "duration": 1200, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                        <div
                            className="bg-white border-radius-6px box-shadow-quadruple-large p-10 ps-12 pe-12 lg-ps-8 lg-pe-8 h-100 d-flex flex-wrap flex-column justify-content-center"
                            data-anime={JSON.stringify({
                                "el": "childs",
                                "translateY": [0, 0],
                                "opacity": [0, 1],
                                "duration": 1200,
                                "delay": 0,
                                "staggervalue": 150,
                                "easing": "easeOutQuad"
                            })}>
                            <span
                                className="ps-25px pe-25px mb-20px text-uppercase text-base-color fs-12 lh-40 fw-700 border-radius-100px bg-gradient-very-light-gray-transparent d-inline-flex align-self-start"><i
                                className="bi bi-chat-square-dots fs-16 me-5px"></i>Vegyük fel a kapcsolatot!</span>
                            <h4 className="text-dark-gray ls-minus-1px fw-700 mb-15px">Kérdésed van?</h4>
                            <p className="w-85 sm-w-100">Tedd fel bátran az alábbi űrlap segítségével, vagy írj nekünk az <a className="fw-700" href={'mailto:info@benefitprize.hu'}>info@benefitprize.hu</a> email címre!</p>
                        </div>
                    </div>
                    <div className="col-lg-6 offset-xl-1 md-mb-50px sm-mb-0"
                         data-anime={JSON.stringify({
                             "el": "childs",
                             "translateX": [50, 0],
                             "opacity": [0, 1],
                             "duration": 1200,
                             "delay": 0,
                             "staggervalue": 150,
                             "easing": "easeOutQuad"
                         })}>

                        {!finished && <form className="contact-form-style-03">
                            <h3 className="text-dark-gray ls-minus-2px fw-700">Üzenet küldése</h3>
                            <label htmlFor="exampleInputEmail1"
                                   className="form-label fs-13 text-uppercase text-dark-gray fw-700 mb-0">Név*</label>
                            <div className="position-relative form-group mb-20px"><span className="form-icon"><i
                                className="bi bi-emoji-smile text-dark-gray"></i></span>
                                <input
                                    className="fs-15 ps-0 border-radius-0px border-color-dark-gray bg-transparent form-control required"
                                    id="name" type="text" name="name"
                                    placeholder="Kérjük add meg a teljes nevedet!"/>
                            </div>
                            <label htmlFor="exampleInputEmail1"
                                   className="form-label fs-13 text-uppercase text-dark-gray fw-700 mb-0">Email cím*</label>
                            <div className="position-relative form-group mb-20px"><span className="form-icon"><i
                                className="bi bi-envelope text-dark-gray"></i></span>
                                <input
                                    className="fs-15 ps-0 border-radius-0px border-color-dark-gray bg-transparent form-control required"
                                    id="email" type="email" name="email"
                                    placeholder="Kérjük add meg az email címedet!"/>
                            </div>
                            <label htmlFor="exampleInputEmail1"
                                   className="form-label fs-13 text-uppercase text-dark-gray fw-700 mb-0">Üzeneted</label>
                            <div className="position-relative form-group form-textarea mb-0">
                                <textarea
                                    className="fs-15 ps-0 border-radius-0px border-color-dark-gray bg-transparent form-control"
                                    name="comment" placeholder="Kérjük írd meg miben segíthetünk!" rows="3"
                                    id={'message'}></textarea> <span
                                className="form-icon"><i className="bi bi-chat-square-dots text-dark-gray"></i></span>
                            </div>
                            <div className="row mt-25px align-items-center">
                                <div className="col-xl-7 col-lg-12 col-sm-7 lg-mb-30px md-mb-0">

                                </div>
                                <div
                                    className="col-xl-5 col-lg-12 col-sm-5 text-center text-sm-end text-lg-start text-xl-end xs-mt-25px">
                                    <input id="exampleInputEmail3" type="hidden" name="redirect" value=""/>
                                    <button
                                        className="btn btn-dark-gray btn-medium btn-round-edge btn-box-shadow submit"
                                        onClick={submitQuestion}>Küldés
                                    </button>
                                </div>
                                <div className="col-12 mt-20px mb-0 text-center text-md-start">
                                    <div className="form-results d-none"></div>
                                </div>
                            </div>
                        </form>
                        }
                        {finished && <h3 className="text-dark-gray ls-minus-2px fw-700">Köszönjük a visszajelzésed!</h3>}
                    </div>
                </div>
            </div>
            <div className="shape-image-animation p-0 w-100 bottom-minus-40px xl-bottom-0px d-none d-md-block">
            </div>
        </section>
    )
}